export const CART_COUNT = "CART_COUNT";
export const PINCODE_DATA = "PINCODE_DATA";
// export const DEVICE_DATA = "DEVICE_DATA";